import { ViewStateType } from 'components/ProductTemplates/types';
import { InvestOffer } from 'views/Invest/types';
import { Button } from 'components';
import { investNowApi } from 'views/Invest/services/investNowApi';
import useApiMutation from 'hooks/useApiMutation';
import { useTranslation } from 'react-i18next';
import errorImage from '../../../assets/images/error.png';
import { FeedbackTemplate, MessageType } from '../FeedbackTemplate';

interface RequestWineOnFailedPurchaseType {
  onStatusChange: (viewState: ViewStateType, message?: MessageType | undefined) => void;
  qtyBought: number;
  resetStatus: () => void;
  onClose?: () => void;
  offer:
    | InvestOffer
    | {
        expiryDate: string;
        price: number;
        subtitle: string;
        name: string;
      };
}

const RequestWineOnFailedPurchase = ({
  onStatusChange,
  qtyBought,
  resetStatus,
  onClose,
  offer,
}: RequestWineOnFailedPurchaseType) => {
  const { name: title, subtitle: subTitle, price, expiryDate } = offer;

  const investRequest = {
    offerTitle: title,
    offerSubTitle: subTitle,
    offerPrice: price,
    numberOfUnits: qtyBought,
    totalPrice: Number(price) * qtyBought,
    offerExpiryDate: expiryDate,
  };
  const { t } = useTranslation();
  const { executor } = useApiMutation(() => investNowApi(investRequest as unknown as InvestOffer));

  const processInvestMore = async () => {
    onStatusChange(ViewStateType.LOADING);
    const result = await executor({});

    if (result?.data?.isSuccess) {
      onStatusChange(ViewStateType.THANK_YOU);
    } else {
      onStatusChange(ViewStateType.ERROR_RESULT);
    }
  };

  return (
    <FeedbackTemplate
      templateConfig={{
        title: (
          <div className="flex flex-col items-center gap-3">
            <div className="w-20 h-20 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
              <img className="w-12 h-12" src={errorImage} alt="errorImage" />
            </div>
            <p className="text-lg font-semibold text-gray-900 dark:text-white">{t('common:error')}</p>
          </div>
        ),
        subTitle: (
          <div className="flex flex-col gap-2">
            <p className="text-sm text-gray-600 dark:text-slate-400 text-center">
              {t('common:purchase_error_message')}
            </p>
          </div>
        ),
        content: () => (
          <div className="flex flex-col gap-3 px-4">
            <Button
              className="btn w-full h-12 text-base font-semibold rounded-full bg-gradient-to-r from-orange to-orange/90 dark:from-teal-500 dark:to-teal-600 text-white shadow-lg shadow-orange/30 dark:shadow-teal-500/30 hover:shadow-xl hover:shadow-orange/40 dark:hover:shadow-teal-500/40 transition-all"
              onClick={() => {
                processInvestMore();
                resetStatus();
              }}
            >
              {t('common:request_purchase')}
            </Button>
            <button
              className="text-sm font-medium text-gray-500 dark:text-slate-400 hover:text-orange dark:hover:text-teal-400 py-2 transition-colors"
              onClick={onClose}
            >
              {t('common:close')}
            </button>
          </div>
        ),
      }}
      viewState={ViewStateType.CUSTOM}
      onCTA={onClose}
    />
  );
};

export default RequestWineOnFailedPurchase;
